import { AddPaymentMethodCTA } from "./ctas";
export var AddPaymentMethodIA = function AddPaymentMethodIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return ADD_PAYMENT_METHOD(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [ADD_PAYMENT_METHOD_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return AddPaymentMethodCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _AddPaymentMethodCTA$, _AddPaymentMethodCTA;
        return (_AddPaymentMethodCTA$ = (_AddPaymentMethodCTA = AddPaymentMethodCTA(strictLocalize)).getLink) === null || _AddPaymentMethodCTA$ === void 0 ? void 0 : _AddPaymentMethodCTA$.call(_AddPaymentMethodCTA);
      }
    }
  };
};
var ADD_PAYMENT_METHOD = function ADD_PAYMENT_METHOD(strictLocalize) {
  return strictLocalize({
    id: "vUmmzL",
    defaultMessage: [{
      "type": 0,
      "value": "Betaalmethoden toevoegen"
    }]
  });
};
var ADD_PAYMENT_METHOD_EXPLANATION = function ADD_PAYMENT_METHOD_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "9bCwIn",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt extra betaalmethoden toevoegen door op de onderstaande knop te klikken. Deze optie bevindt zich op het tabblad Instellingen in het vervolgkeuzemenu Account."
    }]
  });
};